import {createStore, applyMiddleware, compose} from 'redux'
import createSagaMiddleware from 'redux-saga'
import reducers from './reducers/reducers'
import sagas from './sagas/sagas'

const sagaMiddleware = createSagaMiddleware();
const applySagaMiddleware = applyMiddleware(sagaMiddleware);
const reduxExtension = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
const store = createStore(
  reducers,
  reduxExtension
    ? compose(applySagaMiddleware, reduxExtension)
    : compose(applySagaMiddleware),
);

sagaMiddleware.run(sagas);

export default store;